// extracted by mini-css-extract-plugin
export default {"right":"irregular-summary_right__CHBZL"};